<template>
	<div style="margin-top: 0px;">

		<!-- 3.使用组件 -->
		<!-- 页头 -->
		<roheader :shopcart="shopcart" :shopcart_qty="shopcart_qty" :shopcart_total="shopcart_total"
			@data-updated-shopcart="handleShopcartUpdated"></roheader>
		<!-- 内容 -->
		<div style="width:100%;background: #F1F1F1;overflow: auto;padding-bottom: 30px;">
			<div style="width:1200px;margin:auto;padding:20px;">
				<rosidebar :selected_page='selected_page'></rosidebar>
				<div style="float: right;width:calc(100% - 269px);overflow: hidden;height:1090px;background: white;">
					<h5 style="border-bottom: 1px solid #F1F1F1;line-height: 70px;text-align: left;padding-left: 20px;">
						开票记录
					</h5>
					<div style="width: 95%;margin:20px auto;padding:0 10px;border: 2px dotted #F0F0F0;height: 50px;">						
						<el-pagination style=";margin-top: 8px;float: right;" @current-change="handleCurrentChange"
							:current-page="currentPage" :page-size="PageSize" background
							layout="total, prev, pager, next" :total="totalCount">
						</el-pagination>
					</div>
					<el-table :data="tableData" style="width: 95%;margin:30px auto;" stripe>
						<el-table-column prop="name" label="项目名称" width="180">
						</el-table-column>
						<el-table-column prop="invoice_date" label="申请时间" width="100">
						</el-table-column>
						<el-table-column prop="unit_name" label="发票抬头" width="180">
						</el-table-column>
						<el-table-column prop="amount" label="发票总额" width="80">
						</el-table-column>
						<el-table-column prop="note" label="开票备注" width="200">
						</el-table-column>					
						<el-table-column fixed="right"  width="80" >
							<template slot-scope="scope">
								<el-button type="text" size="small" v-if="scope.row.state=='开票中'">{{scope.row.state}}</el-button>								
								<el-button type="text" size="small" v-if="scope.row.url" @click="download_url(scope.row.url)">下载</el-button>															
							</template>
						</el-table-column>
					</el-table>

				</div>

			</div>
		</div>
		<!-- 页脚 -->
		<rofooter></rofooter>
	</div>

</template>



<script>
	import {
		fetchGet,
		fetchPost
	} from "../utils/request"
	import qs from 'qs'
	// 1.导入组件
	import roheader from "./components/ro_header.vue";
	import rofooter from "./components/ro_footer.vue";
	import rosidebar from "./components/ro_sidebar.vue";
	export default {
		name: 'Demo',
		data() {
			return {
				selected_page: '3-3',
				customer_options: [],

				tableData: [],
				currentPage: 1,
				totalCount: 0,
				PageSize: 10,
				shopcart: [],
				shopcart_qty: 0,
				shopcart_total: 0,
				shopcart:'',
			}
		},
		mounted() {
			this.get_log_list()
			this.get_shopcart()
			//第一个对比供应商信息加载
		},
		components: {
			// 2.注册局部组件
			roheader,
			rofooter,
			rosidebar,
		},
		methods: {
			get_shopcart() {
				var shopcart = localStorage.getItem('shopcart');
				if (shopcart == ''||shopcart==null) {
					shopcart = [];
				}
				else{
					shopcart = JSON.parse(shopcart)
				}
				var shopcart_qty = 0
				var shopcart_total = 0
				for (var i = 0; i < shopcart.length; i++) {
					shopcart_qty += shopcart[i].qty
					shopcart_total+=parseFloat(shopcart[i].total)
				}
				
				this.shopcart = shopcart
				this.shopcart_qty = shopcart_qty
				this.shopcart_total = shopcart_total.toFixed(2)
			},
			
			handleShopcartUpdated(updatedData) {
				this.shopcart = parseFloat( updatedData).toFixed(2);
			},
			handleShopcartQtyUpdated(updatedData) {
				this.shopcart_qty =  parseFloat( updatedData).toFixed(2);;
			},
			handleShopcartTotalUpdated(updatedData) {
				this.shopcart_total =  parseFloat( updatedData).toFixed(2);;
			},
			handleCurrentChange(val) {
				console.log(val)
				console.log('handleCurrentChange')
				this.currentPage = val
				this.get_log_list()
			},
			
			download_url(row) {
				console.log(row)
				window.open(row,"_blank");        
			},
			get_log_list() {
				var data = {
					'id': window.localStorage.getItem('eshop_user_id'),
					'page': this.currentPage,
					'page_size': this.PageSize,
				}
				console.log(data)
				var self = this
				fetchPost('/ro/eshop/invoice/log/list/v1', data).then(response => {
					console.log(response)
					self.tableData = response.data.list
					self.totalCount = response.data.totalCount
				})

			},

		}
	}
</script>
<style>
	@import url("../static/css/css2.css");
	@import url("../static/css/app.min.css");
	@import url("../static/css/fontawesome.min.css");
	@import url("../static/css/animate.min.css");
	@import url("../static/css/style.css");

	#app {
		margin-top: 0px !important;
	}

	table {
		margin: 0 !important;
	}

	.el-table__body,
	.el-table__footer,
	.el-table__header {
		border-collapse: collapse !important;
	}

	.el-table th {
		text-align: center !important;
		background-color: #F0F0F0;
		color: #333;
	}

	.el-table td {
		text-align: center !important;
	}
</style>
